/* ════════════════════════════════════════════════════════════════════
   ISOFIN® Messskizzen-System — Tool-Logik (messprotokoll-Seite)
   ────────────────────────────────────────────────────────────────────
   Raster aus Wandmaßen · editierbare Messpunkte · Feuchtigkeits-Heatmap
   (IDW-Interpolation) · Messungs-Navigation · CSV-Export/Import.
   Aktiv nur wenn #isomess-app existiert (sonst no-op).
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var app = document.getElementById('isomess-app');
  if (!app) return;

  function byId(id) { return document.getElementById(id); }
  function show(id) { var e = byId(id); if (e) e.style.display = ''; }

  // ── Logr3-Funnel-Tracking (View → Generate → Export), je 1× pro Session ──
  var tracked = {};
  function track(name) {
    if (tracked[name]) return;
    tracked[name] = true;
    try {
      if (typeof window.logr3Track === 'function') window.logr3Track(name, { step: true });
      else if (typeof window.isoTrack === 'function') window.isoTrack(name);
    } catch (e) {}
  }

  // ── State ──────────────────────────────────────────────────────────
  var state = {
    width: 0, height: 0,
    cols: [], rows: [],            // cm-Positionen (aufsteigend = links→rechts / unten→oben)
    measurements: [],              // [{name, date, values:{mp:val}}]
    current: 0
  };

  // ── Farb-Skala 0–100 (grün→gelb→rot, passend zur Legende) ──────────
  var STOPS = [[34,166,110],[255,200,40],[208,16,48]]; // #22A66E #FFC828 #D01030
  function lerp(a, b, t) { return Math.round(a + (b - a) * t); }
  function color(v) {
    if (v == null || isNaN(v)) return '#f1f1f1';
    var t = Math.max(0, Math.min(100, v)) / 100, a, b, tt;
    if (t < 0.5) { a = STOPS[0]; b = STOPS[1]; tt = t / 0.5; }
    else { a = STOPS[1]; b = STOPS[2]; tt = (t - 0.5) / 0.5; }
    return 'rgb(' + lerp(a[0],b[0],tt) + ',' + lerp(a[1],b[1],tt) + ',' + lerp(a[2],b[2],tt) + ')';
  }

  // ── Raster-Positionen aus Wandmaßen ────────────────────────────────
  // Erste Messung 10 cm von Boden/Wand, danach alle 30 cm, min. 10 cm Abstand.
  function buildPositions(w, h) {
    var cols = [], rows = [], x, y;
    for (x = 10; x <= w - 10; x += 30) cols.push(x);
    for (y = 10; y <= h - 10; y += 30) rows.push(y);
    if (cols.length === 0) cols.push(Math.round(w / 2));
    if (rows.length === 0) rows.push(Math.round(h / 2));
    return { cols: cols, rows: rows };
  }
  // MP-Nummer (unten→oben, links→rechts): r=0 ist unten
  function mpNum(r, c) { return r * state.cols.length + c + 1; }
  function pointCount() { return state.cols.length * state.rows.length; }

  function newMeasurement(name, date) {
    return { name: name, date: date || (byId('measurementDate') ? byId('measurementDate').value : ''), values: {} };
  }

  // ── Aktionen ───────────────────────────────────────────────────────
  function generateTable() {
    var w = parseInt(byId('wallWidth').value, 10);
    var h = parseInt(byId('wallHeight').value, 10);
    if (!w || !h || w < 50 || h < 50) {
      alert('Bitte gültige Wandbreite und Wandhöhe eingeben (mindestens 50 cm).');
      return;
    }
    state.width = w; state.height = h;
    var p = buildPositions(w, h);
    state.cols = p.cols; state.rows = p.rows;
    if (state.measurements.length === 0) {
      state.measurements = [newMeasurement('Erste Messung')];
      state.current = 0;
    }
    show('measurementNav'); show('dataPanel'); show('heatmapPanel'); show('legendSection');
    renderGrid(); renderNav(); updateProgress(); drawHeatmap();
    byId('dataPanel').scrollIntoView({ behavior: 'smooth', block: 'start' });
    track('messprotokoll_generate');
  }

  function addMeasurement() {
    if (!state.cols.length) { generateTable(); return; }
    var n = state.measurements.length + 1;
    var today = new Date(); today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
    state.measurements.push(newMeasurement('Messung ' + n, today.toISOString().slice(0, 10)));
    state.current = state.measurements.length - 1;
    renderGrid(); renderNav(); updateProgress(); drawHeatmap();
  }
  function prevMeasurement() { if (state.current > 0) { state.current--; renderGrid(); renderNav(); updateProgress(); drawHeatmap(); } }
  function nextMeasurement() { if (state.current < state.measurements.length - 1) { state.current++; renderGrid(); renderNav(); updateProgress(); drawHeatmap(); } }

  function clearCurrentData() {
    if (!state.measurements.length) return;
    if (state.measurements.length > 1) {
      if (!confirm('Aktuelle Messung wirklich löschen?')) return;
      state.measurements.splice(state.current, 1);
      if (state.current >= state.measurements.length) state.current = state.measurements.length - 1;
      renderGrid(); renderNav(); updateProgress(); drawHeatmap();
    } else {
      if (!confirm('Messung löschen und neu starten?')) return;
      resetToStart();
    }
  }
  function resetToStart() {
    state.measurements = []; state.cols = []; state.rows = [];
    state.width = 0; state.height = 0; state.current = 0;
    var g = byId('measurementGrid'); if (g) g.innerHTML = '';
    ['measurementNav', 'dataPanel', 'heatmapPanel', 'legendSection'].forEach(function (id) {
      var e = byId(id); if (e) e.style.display = 'none';
    });
    var ind = byId('updateIndicator'); if (ind) ind.style.display = 'none';
    if (byId('wallWidth')) byId('wallWidth').value = '';
    if (byId('wallHeight')) byId('wallHeight').value = '';
    var cfg = document.querySelector('#isomess-app .isomess-config-panel');
    if (cfg) cfg.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // ── Grid rendern (oben→unten visuell) ──────────────────────────────
  // Grid-Style EINMALIG injizieren — isoliert (#measurementGrid-scoped + !important),
  // damit das Theme von außen NICHT reingreift.
  function ensureGridStyle() {
    if (byId('mg-style')) return;
    var s = document.createElement('style');
    s.id = 'mg-style';
    s.textContent = [
      '#measurementGrid .mg-scroll{overflow-x:auto;overflow-y:visible;-webkit-overflow-scrolling:touch;padding:4px 2px 10px;scrollbar-width:thin;scrollbar-color:#E5E5E5 transparent}',
      '#measurementGrid .mg-scroll::-webkit-scrollbar{height:8px}',
      '#measurementGrid .mg-scroll::-webkit-scrollbar-thumb{background:#E5E5E5;border-radius:8px}',
      '#measurementGrid .mg-grid{display:grid!important;gap:12px 12px;width:100%}',
      '#measurementGrid .mg-colhead{position:sticky;top:0;z-index:3;display:flex;flex-direction:column;align-items:center;justify-content:flex-end;gap:1px;padding:2px 0 8px;background:#fff;line-height:1.1}',
      '#measurementGrid .mg-colhead b{font-size:13px!important;font-weight:700;color:#1A1A1A}',
      '#measurementGrid .mg-colhead .u{font-size:9px;font-weight:600;color:#A0A0A0;text-transform:uppercase;letter-spacing:.06em}',
      '#measurementGrid .mg-corner{position:sticky;top:0;left:0;z-index:4;background:#fff}',
      '#measurementGrid .mg-rowhead{position:sticky;left:0;z-index:2;display:flex;flex-direction:column;align-items:flex-end;justify-content:center;gap:0;padding-right:10px;background:#fff;white-space:nowrap;line-height:1.15}',
      '#measurementGrid .mg-rowhead b{font-size:13px!important;font-weight:700;color:#1A1A1A}',
      '#measurementGrid .mg-rowhead .u{font-size:10px;font-weight:600;color:#A0A0A0}',
      '#measurementGrid .mg-chip{box-sizing:border-box!important;-webkit-appearance:none!important;-moz-appearance:textfield;appearance:none!important;width:100%!important;min-width:0;height:52px!important;margin:0!important;border:1.5px dashed #D4D4D6!important;border-radius:12px!important;background:#fff;color:#1A1A1A;font:600 17px/1 Rubik,system-ui,sans-serif!important;text-align:center!important;padding:0 6px!important;box-shadow:none;transition:border-color .15s,box-shadow .18s,background-color .15s,transform .12s;cursor:text;caret-color:#D6001C}',
      '#measurementGrid .mg-chip::-webkit-outer-spin-button,#measurementGrid .mg-chip::-webkit-inner-spin-button{-webkit-appearance:none!important;margin:0}',
      '#measurementGrid .mg-chip::placeholder{color:#C4C4C6}',
      '#measurementGrid .mg-chip:hover{border-color:#BDBDBF!important;background:#FAFAFA}',
      '#measurementGrid .mg-chip.is-filled{border-style:solid!important;border-color:rgba(0,0,0,.06)!important;box-shadow:0 2px 6px rgba(0,0,0,.10),0 1px 2px rgba(0,0,0,.06);font-weight:700}',
      '#measurementGrid .mg-chip.is-filled:hover{transform:translateY(-1px);box-shadow:0 4px 10px rgba(0,0,0,.14),0 1px 3px rgba(0,0,0,.08)}',
      '#measurementGrid .mg-chip:focus{outline:none!important;border-color:#D6001C!important;border-style:solid!important;box-shadow:0 0 0 3px rgba(214,0,28,.18)!important}',
      '#measurementGrid .mg-chip.is-filled:focus{box-shadow:0 0 0 3px rgba(214,0,28,.30),0 2px 6px rgba(0,0,0,.12)!important;transform:translateY(-1px)}',
      '@media(max-width:560px){#measurementGrid .mg-grid{gap:10px 10px!important}#measurementGrid .mg-chip{height:52px!important;font-size:17px!important;padding:0 4px!important;border-radius:12px!important}}'
    ].join('');
    document.head.appendChild(s);
  }

  // ── Grid rendern: Chip-Design + MP/cm-Zeilenlabel links (Anordnung wie Original) ──
  function renderGrid() {
    ensureGridStyle();
    var grid = byId('measurementGrid');
    if (!grid) return;
    var m = state.measurements[state.current];
    var nc = state.cols.length, r, c, mp, val;
    var tmpl = 'minmax(48px,auto) repeat(' + nc + ',minmax(64px,1fr))';
    var h = '<div class="mg-scroll"><div class="mg-grid" style="grid-template-columns:' + tmpl + ';">';
    // Kopfzeile: Ecke + cm-Spalten (Wandabstand), sticky oben
    h += '<div class="mg-corner mg-colhead"></div>';
    for (c = 0; c < nc; c++) h += '<div class="mg-colhead"><b>' + state.cols[c] + '</b><span class="u">cm</span></div>';
    // Datenzeilen oben→unten (höchster cm zuerst). MP = Höhenstufe (MP-1 = unten/10cm).
    for (r = state.rows.length - 1; r >= 0; r--) {
      h += '<div class="mg-rowhead"><b>MP-' + (r + 1) + '</b><span class="u">' + state.rows[r] + ' cm</span></div>';
      for (c = 0; c < nc; c++) {
        mp = mpNum(r, c);
        val = (m && m.values[mp] != null) ? m.values[mp] : '';
        var filled = val !== '';
        var styleAttr = filled ? (' style="background:' + color(+val) + ';color:' + (+val > 45 ? '#fff' : '#1A1A1A') + ';"') : '';
        h += '<input type="number" inputmode="numeric" min="0" max="100" data-mp="' + mp + '" value="' + val + '" '
          + 'aria-label="MP-' + (r + 1) + ', ' + state.cols[c] + ' cm, Feuchtigkeit in Prozent" '
          + 'class="mg-chip' + (filled ? ' is-filled' : '') + '"' + styleAttr + ' />';
      }
    }
    h += '</div></div>';
    grid.innerHTML = h;
  }

  function renderNav() {
    var d = byId('currentMeasurementDisplay');
    var m = state.measurements[state.current];
    if (d && m) d.textContent = m.name + (m.date ? ' · ' + m.date : '') + ' (' + (state.current + 1) + '/' + state.measurements.length + ')';
    var prev = byId('prevMeasurement'), next = byId('nextMeasurement');
    if (prev) prev.disabled = state.current === 0;
    if (next) next.disabled = state.current === state.measurements.length - 1;
  }

  function updateProgress() {
    var m = state.measurements[state.current];
    if (!m) return;
    var total = pointCount(), filled = 0, k;
    for (k in m.values) if (m.values[k] != null && m.values[k] !== '') filled++;
    var st = byId('measurementStatus'), pt = byId('progressText');
    if (st) st.textContent = filled === total ? 'Vollständig' : (filled + '/' + total);
    if (pt) pt.textContent = filled === 0 ? 'Feuchtigkeitswerte direkt in die Tabelle eingeben' : (filled + ' von ' + total + ' Messpunkten erfasst');
  }

  // ── Heatmap (IDW-Interpolation) ─────────────────────────────────────
  var hmTimer = null;
  function scheduleHeatmap() {
    var ind = byId('updateIndicator'); if (ind) ind.style.display = 'block';
    if (hmTimer) clearTimeout(hmTimer);
    hmTimer = setTimeout(function () { drawHeatmap(); if (ind) ind.style.display = 'none'; }, 180);
  }
  function drawHeatmap() {
    var cv = byId('heatmapCanvas');
    if (!cv || !state.width) return;
    var m = state.measurements[state.current];
    // Messpunkte mit Wert sammeln (x,y in cm, y von unten)
    var pts = [], r, c, mp, v;
    for (r = 0; r < state.rows.length; r++) for (c = 0; c < state.cols.length; c++) {
      mp = mpNum(r, c); v = m ? m.values[mp] : null;
      if (v != null && v !== '') pts.push({ x: state.cols[c], y: state.rows[r], v: +v });
    }
    // Achsen-Ränder: links MP (Höhe), unten cm (Wandabstand)
    var ML = 48, MR = 8, MT = 6, MB = 28;
    var innerW = 560, innerH = Math.max(110, Math.round(innerW * state.height / state.width));
    var W = ML + innerW + MR, H = MT + innerH + MB;
    cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d');
    ctx.clearRect(0, 0, W, H);
    function hx(xcm) { return ML + xcm / state.width * innerW; }
    function hy(ycm) { return MT + (1 - ycm / state.height) * innerH; }
    if (!pts.length) {
      ctx.fillStyle = '#f4f4f5'; ctx.fillRect(ML, MT, innerW, innerH);
      ctx.fillStyle = '#999'; ctx.font = '13px Rubik,sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('Werte eingeben für die Feuchtigkeits-Darstellung', ML + innerW / 2, MT + innerH / 2);
    } else {
      var step = 5, px, py, wx, wy, i, wsum, vsum, dx, dy, d2, wgt;
      for (py = 0; py < innerH; py += step) {
        for (px = 0; px < innerW; px += step) {
          wx = px / innerW * state.width;
          wy = state.height - (py / innerH * state.height); // Wand-y unten→oben
          wsum = 0; vsum = 0;
          for (i = 0; i < pts.length; i++) {
            dx = wx - pts[i].x; dy = wy - pts[i].y; d2 = dx * dx + dy * dy;
            if (d2 < 1) { vsum = pts[i].v; wsum = 1; break; }
            wgt = 1 / (d2 * d2); wsum += wgt; vsum += wgt * pts[i].v;
          }
          ctx.fillStyle = color(vsum / wsum);
          ctx.fillRect(ML + px, MT + py, step, step);
        }
      }
      // Messpunkte markieren
      for (i = 0; i < pts.length; i++) {
        ctx.beginPath(); ctx.arc(hx(pts[i].x), hy(pts[i].y), 4.5, 0, 6.2832);
        ctx.fillStyle = '#fff'; ctx.fill();
        ctx.lineWidth = 1.8; ctx.strokeStyle = '#1A1A1A'; ctx.stroke();
      }
    }
    // Rahmen + Achsenbeschriftung
    ctx.strokeStyle = '#E5E5E5'; ctx.lineWidth = 1; ctx.strokeRect(ML + 0.5, MT + 0.5, innerW, innerH);
    ctx.fillStyle = '#888'; ctx.font = '600 10px Rubik,sans-serif';
    ctx.textAlign = 'right'; ctx.textBaseline = 'middle';
    for (r = 0; r < state.rows.length; r++) ctx.fillText('MP-' + (r + 1), ML - 6, hy(state.rows[r]));   // Höhe links
    ctx.textAlign = 'center'; ctx.textBaseline = 'top';
    for (c = 0; c < state.cols.length; c++) ctx.fillText(state.cols[c], hx(state.cols[c]), MT + innerH + 6); // cm unten
    ctx.fillStyle = '#aaa'; ctx.font = '600 9px Rubik,sans-serif';
    ctx.fillText('Wandabstand (cm)', ML + innerW / 2, MT + innerH + 17);
  }

  // ── CSV-Export / Import ────────────────────────────────────────────
  function exportAll() {
    if (!state.cols.length) { alert('Bitte zuerst eine Messung erstellen.'); return; }
    var proj = (byId('projectName').value || 'Messung').trim();
    var rows = [];
    rows.push('# ISOFIN Messprotokoll');
    rows.push('# Projekt;' + proj);
    rows.push('# Wandbreite;' + state.width);
    rows.push('# Wandhoehe;' + state.height);
    var head = ['MP', 'Breite_cm', 'Hoehe_cm'];
    state.measurements.forEach(function (mm) { head.push((mm.name + (mm.date ? ' (' + mm.date + ')' : '')).replace(/;/g, ',')); });
    rows.push(head.join(';'));
    var r, c, mp;
    for (r = 0; r < state.rows.length; r++) for (c = 0; c < state.cols.length; c++) {
      mp = mpNum(r, c);
      var line = [mp, state.cols[c], state.rows[r]];
      state.measurements.forEach(function (mm) { var v = mm.values[mp]; line.push(v == null ? '' : v); });
      rows.push(line.join(';'));
    }
    var blob = new Blob(['﻿' + rows.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = proj.replace(/[^\w\-]+/g, '_') + '_messprotokoll.csv';
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 1000);
    track('messprotokoll_export');
  }

  function triggerImport() { var f = byId('csvImportTable'); if (f) f.click(); }
  function handleImport(file) {
    var reader = new FileReader();
    reader.onload = function (e) {
      try {
        var lines = e.target.result.replace(/^﻿/, '').split(/\r?\n/);
        var w = state.width, h = state.height, headIdx = -1, i, parts;
        for (i = 0; i < lines.length; i++) {
          var L = lines[i].trim(); if (!L) continue;
          if (L.indexOf('# Wandbreite') === 0) w = parseInt(L.split(';')[1], 10);
          else if (L.indexOf('# Wandhoehe') === 0) h = parseInt(L.split(';')[1], 10);
          else if (L.indexOf('# Projekt') === 0) { var pn = L.split(';')[1]; if (pn && byId('projectName')) byId('projectName').value = pn; }
          else if (L.indexOf('MP;') === 0) { headIdx = i; break; }
        }
        if (headIdx < 0) { alert('CSV-Format nicht erkannt.'); return; }
        if (w && h) { byId('wallWidth').value = w; byId('wallHeight').value = h; state.width = w; state.height = h; var p = buildPositions(w, h); state.cols = p.cols; state.rows = p.rows; }
        var header = lines[headIdx].split(';');
        var mNames = header.slice(3);
        state.measurements = mNames.map(function (nm) { return newMeasurement(nm || 'Messung', ''); });
        if (!state.measurements.length) state.measurements = [newMeasurement('Erste Messung')];
        for (i = headIdx + 1; i < lines.length; i++) {
          if (!lines[i].trim()) continue;
          parts = lines[i].split(';');
          var mp = parseInt(parts[0], 10); if (!mp) continue;
          for (var j = 0; j < state.measurements.length; j++) {
            var v = parts[3 + j];
            if (v != null && v !== '') state.measurements[j].values[mp] = +v;
          }
        }
        state.current = 0;
        show('measurementNav'); show('dataPanel'); show('heatmapPanel'); show('legendSection');
        renderGrid(); renderNav(); updateProgress(); drawHeatmap();
      } catch (err) { alert('Import fehlgeschlagen: ' + err.message); }
    };
    reader.readAsText(file);
  }

  // ── Verdrahtung ────────────────────────────────────────────────────
  var actions = {
    generateTable: generateTable, addMeasurement: addMeasurement,
    prevMeasurement: prevMeasurement, nextMeasurement: nextMeasurement,
    clearCurrentData: clearCurrentData, exportAll: exportAll, triggerImport: triggerImport
  };
  app.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]'); if (!btn) return;
    var a = btn.getAttribute('data-action');
    if (actions[a]) { e.preventDefault(); actions[a](); }
  });
  var grid = byId('measurementGrid');
  if (grid) grid.addEventListener('input', function (e) {
    var inp = e.target.closest('input[data-mp]'); if (!inp) return;
    var mp = +inp.getAttribute('data-mp');
    var raw = inp.value;
    var v = raw === '' ? null : Math.max(0, Math.min(100, parseFloat(raw)));
    var m = state.measurements[state.current];
    if (v == null) { delete m.values[mp]; inp.classList.remove('is-filled'); inp.style.background = ''; inp.style.color = ''; }
    else { m.values[mp] = v; inp.classList.add('is-filled'); inp.style.background = color(v); inp.style.color = v > 45 ? '#fff' : '#1A1A1A'; }
    updateProgress(); scheduleHeatmap();
  });
  var fileInp = byId('csvImportTable');
  if (fileInp) fileInp.addEventListener('change', function () { if (this.files && this.files[0]) handleImport(this.files[0]); this.value = ''; });

  // Seitenaufruf des Tools (Funnel-Start)
  track('messprotokoll_view');
})();
